import type { HTMLClass } from '@/types/inputs'

import { InjectionKey, Ref, Slot } from 'vue'

import { PaginatedResponse, PaginationParameters } from '@/types/general'

export interface TableColumn {
    name: string
    property: string
    hidden?: boolean
    sortable?: boolean
    date?: string
    minWidth?: number
    width?: number
    filterable?: ColumnFilterOptions
}

export interface InternalTableColumn extends TableColumn {
    slots?: InternalSlots
    hidden: boolean
    sortable: boolean
    order: number
    draggable?: boolean
    minWidth: number
    booleanColumn: boolean
    class?: HTMLClass
    tooltip?: string
}

export interface InternalTableGroup {
    slots?: InternalSlots
    name: string
    group: string
}

export interface ColumnSize {
    width: number
    x: number
}

export interface ColumnFilter {
    value: string | string[]
    type: ColumnFilterType
}

export interface ColumnFilterOptions {
    dataType: DataType
}

// Taken from Vue - not exported
declare type InternalSlots = {
    [name: string]: Slot | undefined
}
export enum ColumnFilterType {
    Contains = 0,
    NotContains = 1,
    Between = 2,
    NotBetween = 3,
}

export enum DataType {
    String = 0,
    Date = 1,
}

export interface GetDataParameters extends PaginationParameters {
    query?: string
    filter?: Record<string, unknown>
    columnFilters?: string
}

export interface MyTableRef {
    highlightRow: (index: number) => void
}

export const paginatedRowsKey: InjectionKey<PaginatedResponse<Record<string, unknown>>> =
    Symbol('paginatedRows')
export const insertColumnKey: InjectionKey<(column: InternalTableColumn) => void> =
    Symbol('insertColumn')
export const updateColumnKey: InjectionKey<
    (property: string, column: Partial<InternalTableColumn>) => void
> = Symbol('updateColumn')
export const removeColumnKey: InjectionKey<(column: InternalTableColumn) => void> =
    Symbol('removeColumn')
export const organizeColumnsKey: InjectionKey<(refit?: boolean) => void> = Symbol('organizeColumns')
export const columnsKey: InjectionKey<Ref<Map<string, InternalTableColumn>>> = Symbol('columnsKey')
export const columnSizesKey: InjectionKey<Ref<Map<string, ColumnSize>>> = Symbol('columnSizes')
export const refetchKey: InjectionKey<
    ((options?: Partial<GetDataParameters>) => Promise<void>) | undefined
> = Symbol('refetch')
